import { FormTabSummary } from './../../../models/modules/formTab';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GridComponent } from '@progress/kendo-angular-grid';
import { Observable, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { AppRoleListing, AppRoleSummary, AppRoleWithPermissions } from '~/models/administration/approle';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { GridFieldAutorizationSummary } from '~/models/modules/GridFieldAuthorization';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { AppRolesService } from '~/services/administration.ts/approles';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { FormTabAuthorizations } from '~/services/modules/stocks/formTabAuthorization';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutComponent } from '../layout/layout.component';
import { SecurityService } from '~/services/security.service';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { AccountsService } from '~/services/administration.ts/accounts';
import { CustomFieldSummary } from '~/models/modules/customField';

interface DropdownGrid {
  value: string;
}

@Component({
    selector: 'asap-custom-fields',
    templateUrl: './custom-fields.html',
    styleUrls: ['./custom-fields.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomFieldsComponent implements OnInit {
  // nonWhitespaceRegExp: RegExp = new RegExp(/^[a-zA-Z0-9]*$/);
  nonWhitespaceRegExp: RegExp = new RegExp(/^[\w]+([-_\s]{1}[a-z0-9\/\\!@#$%&_-]+)*$/i);
  checked: boolean = false;
  _customFieldsType: any[];
  _customFieldsData: any[] = [];
  _switchValue: string = 'String';
  _customFieldTypeControl = new FormControl('String');
  _customFieldValueControl = new FormControl('', [Validators.required, Validators.pattern(this.nonWhitespaceRegExp)]);
  _customFieldValueControlInitValue: GridFieldTextSummary;
  _allCustomFieldValueControl: GridFieldTextSummary[];
  _myForm: any;
  _theme: string;
  _dropdownGridData: DropdownGrid[] = [];
  _dropdownForm: FormGroup;
  _formTabs: any[];
  _form: FormGroup;
  _securityLevel: GridFieldAutorizationSummary[];
  _formTabSecurityLevel: FormTabAuthorizations[];
  _isRequired: boolean;
  _customField: any;
  _appRoles: AppRoleWithPermissions[];
  _ischeckedview: boolean = false;

  @Input() formName: string;
  @Input() isRenameForm: boolean = false;
  @Input() isCustomtabsForm: boolean = false;
  @Input() isCustomfieldsForm: boolean = false;
  @Input() isRenameCustomForm: boolean = false;
  @Input() tabGroup: number;
  @Input() labelId: number;
  @Input() labelObjectCode: string;
  @Input() page: string;
  @Input() permissionScope: string;
  @Input() customFields: Array<any> = [];
  @Input() accounts: any[];
  @Input() language: string;
  @Input() isRenameLabel: boolean = false;
  _isMandatory: boolean = false;
  @Input()
  set isMandatory(input: boolean) {
    this._isMandatory = input;
  }
  get isMandatory(): boolean {
    if (this._isMandatory == true) { this._isRequired = true; }
    return this._isMandatory;
  }
  @Input() isTransaction: boolean = false;
  @Input() onlyRequired: boolean = false;
  @Input() hasRequired: boolean = false;

  @Output() closePopup = new EventEmitter<boolean>();

  @ViewChild('dropdown_grid') private dropDownGridRef: GridComponent;
  _isEnterprise: boolean = false;
  _selectedAccounts: any[] = [];
  constructor(
    private _customFieldsService: CustomFieldsService,
    private _themeManager: ThemeManagerService,
    private _layoutComponent: LayoutComponent,
    private _fb: FormBuilder,
    private _gridFields: GridFieldsService,
    private _appRolesService: AppRolesService,
    private _gridFieldService: GridFieldsService,
    private _securityService: SecurityService,
    private _accountsService: AccountsService
  ) {
    this._isEnterprise = this._securityService.currentUser.isEnterprise;
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._customFieldTypeControl.valueChanges.subscribe((x) => {
      this._switchValue = x;
    });

    if (this.isCustomtabsForm || this.isCustomfieldsForm)
      this._customFieldValueControl.setValue('');

  }
  allFields: GridFieldTextSummary[]
  allCustomFields: CustomFieldSummary[]
  ngOnInit() {
    //this._LoadFormTabsDD();
    if (this.isCustomfieldsForm == true) {
      this.isMandatory = false;
      this._isRequired = false;
    }
    this._gridFields.getGridFieldTextLabelByPage(this.page, this.language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this.allFields = data
      });
    this._appRolesService
      .getAppRolesListing()
      //.getAppRolesListingOnly()

      .subscribe((data: AppRoleWithPermissions[]) => {
        this._appRoles = data;
        //this.onAddSecurityLevel();
        if (!this.labelId && !this.isCustomtabsForm && !this.isRenameForm) {
          this._securityLevel = new Array<GridFieldAutorizationSummary>(this._appRoles.length);
          for (let i = 0; i < this._appRoles.length; i++) {
            this._securityLevel[i] = new GridFieldAutorizationSummary();
            this._securityLevel[i].appRole = this._appRoles[i];
            if (i + 1 === 1) {
              this._securityLevel[i].defaultCanAdd = false;
              this._securityLevel[i].defaultCanDelete = false;
              this._securityLevel[i].defaultCanEdit = false;
              this._securityLevel[i].defaultCanView = true;
            } else if (i + 1 === 2) {
              this._securityLevel[i].defaultCanAdd = true;
              this._securityLevel[i].defaultCanDelete = false;
              this._securityLevel[i].defaultCanEdit = true;
              this._securityLevel[i].defaultCanView = true;
            }
          }
        }

        if (this.isCustomtabsForm) {
          this._formTabSecurityLevel = new Array<FormTabAuthorizations>(this._appRoles.length);
          for (let i = 0; i < this._appRoles.length; i++) {
            this._formTabSecurityLevel[i] = new FormTabAuthorizations();
            this._formTabSecurityLevel[i].appRole = this._appRoles[i];
            if (i + 1 === 1) {
              // this._formTabSecurityLevel[i].defaultCanAdd = false;
              // this._formTabSecurityLevel[i].defaultCanDelete = false;
              this._formTabSecurityLevel[i].defaultCanEdit = false;
              this._formTabSecurityLevel[i].defaultCanView = true;
            } else if (i + 1 === 2) {
              // this._formTabSecurityLevel[i].defaultCanAdd = true;
              // this._formTabSecurityLevel[i].defaultCanDelete = false;
              this._formTabSecurityLevel[i].defaultCanEdit = true;
              this._formTabSecurityLevel[i].defaultCanView = true;
            }
          }


        }

      });
    this._customFieldsService
      .getEntity(this.formName)

      .subscribe((data) => {
        this._myForm = data;
      });
    this._customFieldsService
      .getCustomFieldsType()

      .subscribe((data) => {
        this._customFieldsType = data;
      });
    // this._customFieldsService
    //   .getCustomFields(this,this.page,)
    //   
    //   .subscribe((data) => {

    //     this._customFieldsType = data;
    //   });
    this._customFieldsService
      .getCustomFields('stock', this.page)

      .subscribe((data) => {
        this.allCustomFields = data
      });

    if (this.labelId != null && (!this.isCustomtabsForm && !this.isCustomfieldsForm) && this.isRenameCustomForm) {
      this._customFieldsService
        .getCustomFieldById(this.labelId)

        .subscribe((data) => {



          //     this._customFieldsService
          //     .getCustomFields('stock',this.page)
          //     
          //     .subscribe((data) => {
          //       this.allCustomFields = data


          //     });

          if (this._securityService.currentUser.isEnterprise) {
            if (data.customFieldAccounts && data.customFieldAccounts.length > 0)
              var SavedCustomFieldAccounts: number[] = [];
            this.accounts.forEach(element => {
              if (data.customFieldAccounts.find(x => x.accountId == element))
                SavedCustomFieldAccounts.push(element);
            });
            this.accounts = SavedCustomFieldAccounts;
          }
          this._customFieldValueControl.setValue(data.name);
          this._customFieldTypeControl.setValue(data.customFieldType.type);
          this.getCustomFieldAuth(data.name);
          this._isRequired = data.isRequired;
        });
    }

    if (this.isRenameLabel) {
      this._gridFields.getGridFieldTextLabelByPage(this.page, this.language)

        .subscribe((data: GridFieldTextSummary[]) => {
          let checkFieldObject = data.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === this.labelObjectCode);
          this._customFieldValueControlInitValue = checkFieldObject
          this._allCustomFieldValueControl = data
          let checkField = data.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === this.labelObjectCode)?.currentText;
          if (checkField) {
            this._customFieldValueControl.setValue(checkField);
            this._isRequired = data.find((x) => x.gridFieldDefinition.objectCode === this.labelObjectCode).isRequired
              ? data.find((x) => x.gridFieldDefinition.objectCode === this.labelObjectCode).isRequired
              : false;
          }
        }
        );
      this._gridFields.getRenameAuthByObjectCode(this.labelObjectCode)

        .pipe(first())
        .subscribe((data: GridFieldAutorizationSummary[]) => {
          this._securityLevel = data;

          this._initForm();
          // this._LoadFormTabsDD();
        });
    }
    this._initForm();
    //this.getEditForm();
    this._LoadFormTabsDD();
    if (this.isCustomfieldsForm == true)
      this._customFieldValueControl.setValue('');
  }
  _getAccounts = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  };
  // getEditForm(){
  //     
  //     .subscribe((x: FormTabSummary[]) => {

  //       x.forEach(element => {
  //        if(element.formTabAuthorizations && element.formTabAuthorizations.length > 0)
  //        {
  //         element.formTabAuthorizations.forEach(child => {
  //           this._formTabSecurityLevel.push(child);
  //         });

  //        }
  //       });

  //   });
  // }

  private _initForm() {
    this._form = this._fb.group({
      formtab: [null, Validators.required],
    });
  }

  _LoadFormTabsDD() {
    return this._gridFields
      .getformTabsByPage(this.page)
      .subscribe({
        next: (data: any) => {
          if (data && Array.isArray(data)) {
            if (!data.find((x: any) => x.name === 'General')) {
              data.unshift({
                id: 1,
                name: 'General',
                page: this.page,
                isCustom: false,
                order: 1
              });
            }
            this._formTabs = data;
          } else {
            this._formTabs = data || [];
          }

          setTimeout(() => {
            this._form.patchValue({
              formtab: this._formTabs?.filter(c => c.id == this.tabGroup)[0]
            });
          });
        },
        error: () => {
          this._customFieldsService.getFormTabsByPage(this.page).subscribe((data: any) => {
            if (data && Array.isArray(data)) {
              if (!data.find((x: any) => x.name === 'General')) {
                data.unshift({
                  id: 1,
                  name: 'General',
                  page: this.page,
                  isCustom: false,
                  order: 1
                });
              }
              this._formTabs = data;
            }
            setTimeout(() => {
              this._form.patchValue({
                formtab: this._formTabs?.filter(c => c.id == this.tabGroup)[0]
              });
            });
          });
        }
      });
  }

  //#region  _addCustomField
  _addCustomField(saveAndClose: boolean) {
    let all = this.allFields
    let currentTextExist = all.some(x => x.currentText.toLowerCase() == this._customFieldValueControl.value.toLowerCase());
    if (currentTextExist) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: `Field Name: ${this._customFieldValueControl.value} Already Exist!`,
        withoutConfirm: true
      });
      return
    }
    let allCustomFields = this.allCustomFields.filter(x => x.id != (this._customFieldValueControlInitValue?.id ?? this.labelId))
    let currentTextExistCustomFields = allCustomFields.some(x => x.name.toLowerCase() == this._customFieldValueControl.value.toLowerCase());
    if (currentTextExistCustomFields) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: `Field Name: ${this._customFieldValueControl.value} Already Exist!`,
        withoutConfirm: true
      });
      return
    }

    const secs: any[] = !this.isCustomtabsForm ? this._securityLevel : this._formTabSecurityLevel;
    const secsClone: any[] = [];
    if (!this.isCustomtabsForm) {
      if (secs) {
        secs.forEach((element: any) => {
          secsClone.push(Object.assign({}, element));
        });
        secsClone.find((x: any) => {
          x.appRole = null;
          x.gridFieldDefinition = null;
        });
      }

    }
    if (this.isCustomtabsForm) {
      if (secs) {
        secs.forEach((element: any) => {
          secsClone.push(Object.assign({}, element));
        });
        secsClone.find((x: any) => {
          x.appRole = null;
        });
      }

    }
    if (this._customFieldValueControl.value) {
      if (!this._form.value.formtab?.id && !this.isCustomtabsForm) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Tab is required!',
          withoutConfirm: true
        });
        return;
      }
      if (!this._isRequired) {
        if (secsClone.filter((x: any) => x.canView == true || x.canEdit == true).length == 0) {
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Please choose at least one security level',
            withoutConfirm: true
          });
          return;
        }
      }
      let model: any = {
        name: this._customFieldValueControl.value,
        customFieldTypeId: this._customFieldsType.find(x => x.type == this._switchValue).id,
        customFieldEntityId: this._myForm,
        formTabId: !this.isCustomtabsForm ? (this._form.value.formtab?.id ?? this.tabGroup) : -1,
        page: this.page,
        isCustom: this.isCustomtabsForm ? true : false,
        accountIds: Array.from(new Set(this.accounts.map(item => item))),
        securityLevel: secsClone,
        formTabSecurityLevel: secsClone,
        isRequired: this._isRequired
      };

      if (this.isCustomtabsForm) {
        model['formTabSecurityLevel'] = this._formTabSecurityLevel;
        delete model['securityLevel'];
      }
      else {
        delete model['formTabSecurityLevel'];
      }

      if (this._switchValue == 'Dropdown') {
        model['customFieldOptions'] = this._dropdownGridData;
      }
      if (this.labelId == null) {
        if (this.isCustomtabsForm) {

          model['formTabSecurityLevel'] = this._formTabSecurityLevel;
          this._customFieldsService
            .createCustomTab(model)

            .subscribe((response: any) => {
              if (response.dataId)
                this.labelId = response.dataId;
              if (response['close'] != null
                &&
                response['close'] == true
                &&
                saveAndClose) {
                this.closePopup.emit(true);
              }


              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              //this._customFieldValueControl.setValue('');
              this._dropdownGridData = [];
            });
        } else {

          model['securityLevel'] = this._securityLevel;
          this._customFieldsService
            .createCustomField(model)

            .subscribe((response: any) => {
              // if(response.dataId)
              // this.labelId = response.dataId;
              if (response['close'] != null
                &&
                response['close'] == true
                &&
                saveAndClose) {
                this.closePopup.emit(true);
              }



              if (this.isCustomtabsForm) {
                var msg = 'Custom Field added successfully!';
                msg = 'Custom Tab added successfully!';
                this._layoutComponent.openPopup({
                  title: 'Notification',
                  message: msg,
                  withoutConfirm: true
                });
              }
              else {
                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: response['message'],
                  withoutConfirm: true
                });
              }

              // this.getCustomFieldAuth(this._customFieldValueControl.value);
              this._customFieldValueControl.setValue('');
              this._dropdownGridData = [];
            });
        }
      } else {
        if (this.isCustomtabsForm) {
          this._customFieldsService
            .updateCustomTab(this.labelId, model)

            .subscribe((response: any) => {
              if (response != null && response['message'] != null) {

                if (response['close'] != null
                  &&
                  response['close'] == true
                  &&
                  saveAndClose) {
                  this.closePopup.emit(true);
                }

                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: response['message'],
                  withoutConfirm: true
                });
                if (response['close'] != null) {
                  if (response['close'] == true) {
                    // this._closeForm();
                  } else {
                    return;
                  }
                }
              }
              //   this._closeForm();
            });
        } else {
          this._customFieldsService
            .updateCustomField(this.labelId, model)

            .subscribe((response: any) => {

              if (response != null && response['message'] != null) {

                if (response['close'] != null
                  &&
                  response['close'] == true
                  &&
                  saveAndClose) {
                  this.closePopup.emit(true);
                }

                this._layoutComponent.openPopup({
                  title: 'Alert',
                  message: response['message'],
                  withoutConfirm: true
                });
                if (response['close'] != null) {
                  if (response['close'] == true) {
                    // this._closeForm();
                  } else {
                    return;
                  }
                }
              }
              //   this._closeForm();
              //this.ngOnChanges();
            });
        }
      }
    } else {
      if (!this._customFieldValueControl.value) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Field name is required!',
          withoutConfirm: true
        });
      }
      // else if(!this._form.value.formtab && !this.isCustomtabsForm)
      // {

      // }

    }
  }
  //#endregion
  _editLabel(saveAndClose: boolean) {

    let all = this._allCustomFieldValueControl.filter(x => x.id != this._customFieldValueControlInitValue.id)
    let currentTextExist = all.some(x => x.currentText.toLowerCase() == this._customFieldValueControl.value.toLowerCase());
    if (currentTextExist) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: `Field Name: ${this._customFieldValueControl.value} Already Exist!`,
        withoutConfirm: true
      });
      return
    }

    let allCustomFields = this.allCustomFields.filter(x => x.id != this._customFieldValueControlInitValue.id)
    let currentTextExistCustomFields = allCustomFields.some(x => x.name.toLowerCase() == this._customFieldValueControl.value.toLowerCase());
    if (currentTextExistCustomFields) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: `Field Name: ${this._customFieldValueControl.value} Already Exist!`,
        withoutConfirm: true
      });
      return
    }


    const secs: any[] = this._securityLevel;
    const secsClone: any[] = [];
    secs.forEach((element: any) => {
      secsClone.push(Object.assign({}, element));
    });
    secsClone.find((x: any) => {
      x.appRole = null;
      x.gridFieldDefinition = null;
    });
    if (this._customFieldValueControl.valid) {
      if (this.labelObjectCode) {
        let model: any = {
          currentText: this._customFieldValueControl.value,
          objectCode: this.labelObjectCode,
          languageCode: this.language,
          securityLevel: secsClone,
          isRequired: this._isRequired,
          pageName: this.page
        };
        this._gridFields.updateGridFieldTextLabelByObjectCode(model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              if (saveAndClose) {
                this.closePopup.emit(true);
              }
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close']) {
                  // this._closeForm();
                } else {
                  return;
                }
              }
            }
            // this.getCustomFieldAuth(this._customFieldValueControl.value);
          });
      } else {
        this._layoutComponent.openPopup({
          title: 'Alert',
          message: 'Something is wrong',
          withoutConfirm: true
        });
      }
    } else if (this.onlyRequired) {
      if (this.labelObjectCode) {
        let model: any = {
          objectCode: this.labelObjectCode,
          languageCode: this.language,
          isRequired: this._isRequired
        };
        this._gridFields.updateGridFieldTextLabelByObjectCode(model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {

              if (saveAndClose) {
                this.closePopup.emit(true);
              }

              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close']) {
                  // this._closeForm();
                } else {
                  return;
                }
              }
            }
            // this.getCustomFieldAuth(this._customFieldValueControl.value);
          });
      } else {
        this._layoutComponent.openPopup({
          title: 'Alert',
          message: 'Something is wrong',
          withoutConfirm: true
        });
      }
    }
    else {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Field name is invalid!',
        withoutConfirm: true
      });
    }
  }

  _addHandler() {
    this._dropdownForm = this._fb.group({
      value: ''
    });

    this.dropDownGridRef.addRow(this._dropdownForm);
  }

  _cancelHandler({ sender, rowIndex }: any) {
    sender.closeRow(rowIndex);
  }

  _saveHandler({ sender, rowIndex }: any) {
    this._dropdownGridData.push({ value: this._dropdownForm.get('value').value });
    sender.closeRow(rowIndex);
  }

  _removeHandler({ sender, dataItem }: any) {
    this._dropdownGridData = this._dropdownGridData.filter((x: any) => x.value != dataItem.value);
    sender.cancelCell();
  }

  public addCustomDDLFieldValue(
    newCustomFieldName: string,
    newCustomFieldValue: string
  ) {
    if (newCustomFieldName) {
      this._customFieldsData.push({
        value: newCustomFieldValue
      });
    }
  }

  public cancelAdd() {
    this.checked = false;
    this._switchValue = '';
  }

  public showCustomFields(event: any) {
    this._switchValue = event.type;
    this.checked = true;
  }

  setAsDefault(roleName: string) {
    let model = {
      objectCode: this.labelObjectCode,
      appRoleName: roleName
    };
    this._gridFields.updateRenameAuthByObjectCode(model)

      .subscribe((x: GridFieldAutorizationSummary[]) => {
        this._securityLevel = x;
        this._initForm();
        this._LoadFormTabsDD();
      });
  }

  setAsDefaultCustomField(roleName: string) {
    let model = {
      appRoleName: roleName,
      name: this._customField,
      page: this.page
    };
    if (this._customField) {
      this._gridFields.updateCustomAuthBuName(model)

        .subscribe((x: GridFieldAutorizationSummary[]) => {
          this._securityLevel = x;
          this._initForm();
          this._LoadFormTabsDD();
        });
    } else {
      if (this.isCustomtabsForm) {
        this._formTabSecurityLevel.find((x: FormTabAuthorizations) => x.appRole.name === roleName).canView = this._formTabSecurityLevel.find((x => x.appRole.name === roleName)).defaultCanView;
        this._formTabSecurityLevel.find((x: FormTabAuthorizations) => x.appRole.name === roleName).canEdit = this._formTabSecurityLevel.find((x => x.appRole.name === roleName)).defaultCanEdit;
      }
      this._securityLevel.find((x => x.appRole.name === roleName)).canAdd = this._securityLevel.find((x => x.appRole.name === roleName)).defaultCanAdd;
      this._securityLevel.find((x => x.appRole.name === roleName)).canDelete = this._securityLevel.find((x => x.appRole.name === roleName)).defaultCanDelete;
      this._securityLevel.find((x => x.appRole.name === roleName)).canEdit = this._securityLevel.find((x => x.appRole.name === roleName)).defaultCanEdit;
      this._securityLevel.find((x => x.appRole.name === roleName)).canView = this._securityLevel.find((x => x.appRole.name === roleName)).defaultCanView;
    }
  }

  getCustomFieldAuth(name: string) {
    this._gridFields
      .getCustomFieldAuthByName(name, this.page)

      .subscribe((data: GridFieldAutorizationSummary[]) => {
        this._securityLevel = data;
        this._customField = name;
        this._initForm();
        this._LoadFormTabsDD();
      });
  }

  getSecurityLevelValue(roleName: string) {
    if (this.labelId != null && !this.isCustomtabsForm) {
      return this._securityLevel ?
        this._securityLevel.find((x: GridFieldAutorizationSummary) => x.appRole.name === roleName) :
        new GridFieldAutorizationSummary();
    } else {
      return this._securityLevel ?
        this._securityLevel.find((x: GridFieldAutorizationSummary) => x.appRole.name === roleName) :
        new GridFieldAutorizationSummary();
    }
  }
  getFormTabSecurityLevel(roleName: string) {
    if (this.labelId != null && this.isCustomtabsForm) {
      return this._formTabSecurityLevel ?
        this._formTabSecurityLevel.find((x: FormTabAuthorizations) => x.appRole.name === roleName) :
        new FormTabAuthorizations();
    } else {
      var test = this._formTabSecurityLevel ?
        this._formTabSecurityLevel.find((x: FormTabAuthorizations) => x.appRole.name === roleName) :
        new FormTabAuthorizations();
      return test;
    }
  }

  canSetSecurityLevel(operation: string, role: AppRoleWithPermissions) {
    var test = role.permissions.find(p => p.scope === this.permissionScope && p.operation === operation);
    return test//role.permissions.find(p => p.scope === this.permissionScope && p.operation === operation);
  }

  onValueChange(value: boolean, permission: string, roleName: string, roleHtmlId: any) {

    if (permission == 'view' && !value) {
      if (this.isCustomtabsForm) {
        this.getFormTabSecurityLevel(roleName).canEdit = false;
        // const input = document.getElementById('edit_' + roleHtmlId) as HTMLInputElement | null;
        // input.checked = false;
      }
      else {
        this.getSecurityLevelValue(roleName).canEdit = false;
      }
    }
    else if (permission == 'edit' && value) {
      if (this.isCustomtabsForm) {
        this.getFormTabSecurityLevel(roleName).canView = true;
        // const input = document.getElementById('view_' + roleHtmlId) as HTMLInputElement | null;
        // input.checked = true;
      }
      else {
        this.getSecurityLevelValue(roleName).canView = true;
      }
    }
    // alert("Can Edit " + JSON.stringify(this.getFormTabSecurityLevel(roleName).canEdit));
    // alert("Can View " + JSON.stringify(this.getFormTabSecurityLevel(roleName).canView));
  }
  closeForm(event: boolean) {
    this.closePopup.emit(event);
  }
}

